import React from 'react';
import { Stagger, Item } from './motion';

const teamMembers = [
  {
    name: 'Alexandru Sima',
    role: 'Fondator & Director Tehnic',
    experience: 'Conduce direcția tehnică a companiei și arhitectura celor trei aplicații. Inginerie software și AI aplicat în context juridic.',
  },
  {
    name: 'CII Sima Laura',
    role: 'Operațiuni & Financiar',
    experience: '23 de ani de experiență în operațiuni de business. Aduce în produse perspectiva practicii de zi cu zi și se ocupă de partea financiară.',
  },
  {
    name: 'Echipa de Dezvoltare',
    role: 'Inginerie & AI',
    experience: 'Ingineri software și specialiști AI care construiesc, găzduiesc și întrețin Ortexo, Borderou și Plicuri.',
  },
];

export const Team = () => (
  <section id="team" className="section">
    <div className="container">
      <Stagger>
        <Item as="h2" className="hm-h2">Oamenii din spatele produselor.</Item>
        <Item as="p" className="hm-sub">
          O echipă mică, în care partea tehnică și practica juridică stau la aceeași masă.
          Asta ține produsele aproape de munca reală de cabinet.
        </Item>
      </Stagger>

      <Stagger className="team-list">
        {teamMembers.map((m) => (
          <Item key={m.name} className="team-item">
            <h3 className="team-name">{m.name}</h3>
            <p className="team-role">{m.role}</p>
            <p className="team-bio">{m.experience}</p>
          </Item>
        ))}
      </Stagger>
    </div>
  </section>
);

export default Team;
